import { Col, Row } from "react-bootstrap"
import MoleculeInputNumber from "./MoleculeInputNumber"
import { useEffect } from "react"
import MoleculeCheckBox from "./MoleculeCheckBox"

const MoleculeCheckBoxAndInputNumber = ({ cbLabel = '', cbTooltip = '', cbValue = 0, cbOnChange = null,
    ipLabel = '', ipTooltip = '', ipValue = 0, ipOnChange = null, ipMin = 0 }) => {
    return (
        <Col>
            <Row>
                <MoleculeCheckBox label={cbLabel} tooltip={cbTooltip} value={cbValue} onChange={cbOnChange} />
            </Row>
            <Row>
                <MoleculeInputNumber label={ipLabel} tooltip={ipTooltip} value={ipValue} onChange={ipOnChange} min={ipMin} disable={cbValue == 0} />
            </Row>
        </Col>
    )

}
export default MoleculeCheckBoxAndInputNumber
